import {alias, createModelSchema, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {WorkerKind} from "@/modules/redactor/models/worker/WorkerKind";
import { HeroKindStoreUtils } from "../../../mherokind/database/HeroKindStoreUtils";

export class HeroKind extends Cloneable {
    static NONE = new HeroKind(0, "none", "NONE", 0);

    /*static _values = [
        this.NONE,
        new HeroKind(1, "ch_girl", "CH_GIRL", 10),
        new HeroKind(2, "ch_druid", "CH_DRUID", 10),
        new HeroKind(3, "ch_dwarf", "CH_DWARF", 7),
        new HeroKind(4, "ch_dryad", "CH_DRYAD", 11),
        new HeroKind(5, "ch_north", "CH_NORTH", 8),
        new HeroKind(6, "ch_potter", "CH_POTTER", 8),
        new HeroKind(7, "ch_perfumer", "CH_PERFUMER", 8),
        new HeroKind(8, "ch_shoemaker", "CH_SHOEMAKER", 7),

        new HeroKind(10, "ch_aron", "CH_ARON", 7),
        new HeroKind(9, "ch_lia", "CH_LIA", 7),
        new HeroKind(12, "ch_johan", "CH_JOHAN", 1),

        new HeroKind(16, "ch_champion", "CH_CHAMPION", 1),
        new HeroKind(14, "ch_rinda", "CH_RINDA", 1),
        new HeroKind(13, "ch_vicky", "CH_VICKY", 3),
        new HeroKind(15, "ch_thomas", "CH_THOMAS", 1),
        new HeroKind(20, "ch_harry", "CH_HARRY", 7),
        new HeroKind(21, "ch_shop_trader", "CH_SHOP_TRADER", 1),
        new HeroKind(22, "ch_king", "CH_KING", 7),
        new HeroKind(23, "ch_mermaid", "CH_MERMAID", 1),
        new HeroKind(24, "ch_mermaid_me", "CH_MERMAID_ME", 4),

        new HeroKind(17, "ch_bee", "CH_BEE", 0),
        new HeroKind(18, "ch_sheep", "CH_SHEEP", 0),
        new HeroKind(19, "ch_silkbunny", "CH_SILKBUNNY", 0),

        new HeroKind(25, "ch_corinne", "CH_CORINNE", 8), 
        new HeroKind(26, "ch_robot", "CH_ROBOT", 1),
        new HeroKind(27, "ch_troll", "CH_TROLL", 1),
        new HeroKind(28, "ch_governor", "CH_GOVERNOR", 3),
        new HeroKind(32, "ch_warlock", "CH_WARLOCK", 3),
        new HeroKind(33, "ch_mei", "CH_MEI", 1),
        new HeroKind(34, "ch_bunny", "CH_BUNNY", 1),
        new HeroKind(35, "ch_talking_log", "CH_TALKING_LOG", 1),
        new HeroKind(36, "ch_ice_troll", "CH_ICE_TROLL", 1),
        new HeroKind(37, "ch_ghost", "CH_GHOST", 1),
	    new HeroKind(38, "ch_frog_stella", "CH_FROG_STELLA", 1),
        new HeroKind(39, "ch_thomas_stella", "CH_THOMAS_STELLA", 1),

        new HeroKind(1000, "expd_1_ch_tree", "EXPD_1_CH_TREE", 1),
        new HeroKind(1001, "expd_ch_ghost", "EXPD_CH_GHOST", 3),
        new HeroKind(1002, "expd_ch_spirit_stella", "EXPD_SPIRIT_STELLA", 1),

        new HeroKind(1003, "ch_hero_creature_fire", "HERO_CREATURE_FIRE", 1),
        new HeroKind(1004, "ch_hero_creature_water", "HERO_CREATURE_WATER", 1),
        new HeroKind(1005, "ch_hero_creature_air", "HERO_CREATURE_AIR", 1),
        new HeroKind(1006, "ch_hero_creature_earth", "HERO_CREATURE_EARTH", 1)
    ];*/


    static getValues() {
        return HeroKindStoreUtils.getHeroKinds();
    }

    static getValue(key) {
        let value = this.getValues().find(v => v.key === key) || null;
        console.assert(value, "unknown model: " + key);
        return value;
    }

    static getValueByCode(code) {
        console.log(code);
        let value = this.getValues().find(v => v.code === code) || null;
        console.assert(value, "unknown model: " + code);
        return value;
    }

    static schema() {
        return reference("key", (key, cb) => {
            return cb(null, HeroKind.getValue(key));
        });
    } 
    

    static is(value) {
        if (value instanceof HeroKind) {
            return this.getValues().some(v => v.key === value.key);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return value instanceof HeroKind && value.empty();
    }

    constructor(code = 0, key = "none", name = "None", emotions= 0, worker = null) {
        super();

        this._key = key;
        this._name = name;
        this._code = code;
        this._emotions = emotions;
        this._worker = worker;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    get emotions() {
        return this._emotions;
    }

    set emotions(value) {
        this._emotions = value;
    }

    get worker() {
        return this._worker;
    }

    set worker(value) {
        this._worker = value;
    }

    empty() {
        return typeof this.key !== 'string' || this.key.trim() === '' ||
            !Number.isInteger(this.code) || this.code <= 0 ||
            !Number.isInteger(this.emotions) || this.emotions <= 0;
    }

    equal(value) {
        if (value instanceof HeroKind) {
            return this.key === value.key;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new HeroKind());
        } else if (target instanceof HeroKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(HeroKind, {
    _code: alias("code", Schema.primitive()), 
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()), 
    _emotions: alias("emotions", Schema.primitive()),
    _worker: alias("worker", WorkerKind.schema()),
});


